import styled from 'styled-components';

export const Wrapper = styled.div<{
  backgroundColor?: string;
  fontSize?: string;
  iconColor?: string;
  isRight?: boolean;
  lineHeight?: string;
  textColor?: string;
  padding?: string;
}>`
  padding: ${({ padding }) => padding ?? '8px 16px'};
  gap: 8px;
  display: flex;
  flex-direction: ${({ isRight }) => (isRight ? 'row-reverse' : 'row')};
  align-items: flex-start;
  border-radius: 8px;
  background-color: ${({ backgroundColor }) => backgroundColor ?? '#ecf4f9'};

  > cc-icon {
    color: ${({ iconColor }) => iconColor ?? '#4a4f55'};
  }

  > p {
    font-size: ${({ fontSize }) => fontSize ?? '12px'};
    line-height: ${({ lineHeight }) => lineHeight ?? '16px'};
    color: ${({ textColor }) => textColor ?? '#4a4f55'};
    align-self: center;
    > span {
      font-weight: 700;
    }
  }

  a {
    font-weight: 700;
    color: #5b36f2;
    cursor: pointer;
  }

  & a.link-warning {
    font-weight: 400;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  & a.link-warning:hover {
    color: #745ef6;
    font-weight: 700;
  }

  & a.link-warning:focus-visible {
    color: #4318cd;
    outline: 1px solid #4318cd;
    border-radius: 4px;
  }
`;
